// Canonical display labels for a schedule team member's employment type and
// shift designation. Shared by the Team card and the worker profile panel so
// the two surfaces can't drift.
import type {
  ScheduleTeamMemberType,
  ScheduleTeamShiftPatternType,
  ScheduleTeamShiftType,
} from '@load-balancing/types';

const EMPLOYMENT_LABELS: Record<
  ScheduleTeamMemberType['employmentType'],
  string
> = {
  core: 'Core',
  agency: 'Agency',
};

const SHIFT_TYPE_LABELS: Record<ScheduleTeamShiftType, string> = {
  day: 'Day',
  night: 'Night',
  either: 'Flexible',
};

const SHIFT_PATTERN_LABELS: Record<ScheduleTeamShiftPatternType, string> = {
  consecutive: 'Consecutive',
  non_consecutive: 'Non-consecutive',
  no_preference: 'No Shift Pattern',
};

export function getEmploymentLabel(member: ScheduleTeamMemberType): string {
  return EMPLOYMENT_LABELS[member.employmentType];
}

export function getShiftTypeLabel(member: ScheduleTeamMemberType): string {
  return SHIFT_TYPE_LABELS[member.shiftType];
}

export function getShiftPatternLabel(member: ScheduleTeamMemberType): string {
  return SHIFT_PATTERN_LABELS[member.shiftPattern];
}
